import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';
import { checkActiveSubscriptionPause } from '@utils';

function* setParticipation(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.SET_PARTICIPATION,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.SET_PARTICIPATION_SUCCEEDED
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({ type: types.SET_PARTICIPATION_FAILED, error: response });
    } else if (response.status === ResponseStatus.PROFILE_MISSING_EMAIL) {
      yield put({
        type: types.SET_PARTICIPATION_FAILED_NEED_ACTION
      });
    } else {
      yield put({ type: types.SET_PARTICIPATION_FAILED, error: response });
    }

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.SET_PARTICIPATION_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchSetParticipation() {
  yield takeLatest(types.SET_PARTICIPATION_REQUESTED, setParticipation);
}

// V3 Participation APIs
function* getParticipationUserInfo(action) {
  let response = null;
  const showGeneralPopup = false;
  // loadingはgetDatingDaysで管理するため、ここでは表示しない
  try {
    response = yield call(
      requestAPI,
      API.API_V3_PARTICIPATION_USER_INFO,
      API.GET,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_PARTICIPATION_USER_INFO_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_PARTICIPATION_USER_INFO_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_PARTICIPATION_USER_INFO_FAILED, error });
    if (action.onComplete) {
      action.onComplete({ status: 'error', error });
    }
  }
}

function* getParticipationWeek(action) {
  let response = null;
  const showGeneralPopup = false;
  // loadingはgetDatingDaysで管理するため、ここでは表示しない
  try {
    response = yield call(
      requestAPI,
      API.API_V3_PARTICIPATION_WEEK,
      API.GET,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_PARTICIPATION_WEEK_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.GET_PARTICIPATION_WEEK_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_PARTICIPATION_WEEK_FAILED, error });
    if (action.onComplete) {
      action.onComplete({ status: 'error', error });
    }
  }
}

function* getDatingNeedFeedback(action) {
  let response = null;
  const showGeneralPopup = false;
  // loadingはgetDatingDaysで管理するため、ここでは表示しない
  try {
    response = yield call(
      requestAPI,
      API.API_V3_DATING_NEED_FEEDBACK,
      API.GET,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_DATING_NEED_FEEDBACK_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_DATING_NEED_FEEDBACK_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_DATING_NEED_FEEDBACK_FAILED, error });
    if (action.onComplete) {
      action.onComplete({ status: 'error', error });
    }
  }
}

export function* watchGetParticipationUserInfo() {
  yield takeLatest(
    types.GET_PARTICIPATION_USER_INFO_REQUESTED,
    getParticipationUserInfo
  );
}

export function* watchGetParticipationWeek() {
  yield takeLatest(
    types.GET_PARTICIPATION_WEEK_REQUESTED,
    getParticipationWeek
  );
}

export function* watchGetDatingNeedFeedback() {
  yield takeLatest(
    types.GET_DATING_NEED_FEEDBACK_REQUESTED,
    getDatingNeedFeedback
  );
}

function* requestParticipate(action) {
  let response = null;
  const showGeneralPopup = false;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + `/request-participate`,
      API.POST,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.REQUEST_PARTICIPATE_SUCCEEDED,
        data: response.data
      });
    } else {
      if (checkActiveSubscriptionPause(response)) {
        return;
      }
      yield put({ type: types.REQUEST_PARTICIPATE_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.REQUEST_PARTICIPATE_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* cancelParticipate(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + '/cancel-participate',
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.CANCEL_PARTICIPATE_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.CANCEL_PARTICIPATE_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.CANCEL_PARTICIPATE_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* requestAwaitingCancel(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + '/request-awaiting-cancel',
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.REQUEST_AWAITING_CANCEL_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.REQUEST_AWAITING_CANCEL_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.REQUEST_AWAITING_CANCEL_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* cancelSampleParticipant(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + '/cancel-sample-participate',
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.CANCEL_SAMPLE_PARTICIPANT_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.CANCEL_SAMPLE_PARTICIPANT_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.CANCEL_SAMPLE_PARTICIPANT_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* removeFirstLoginAfterApproved(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(requestAPI, API.API_POPUP_ACKNOWLEDGED, API.POST, {
      popup_type: 'approved_first_login'
    });

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.REQUEST_FIRST_LOGIN_AFTER_APPROVED_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.REQUEST_FIRST_LOGIN_AFTER_APPROVED_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.REQUEST_FIRST_LOGIN_AFTER_APPROVED_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* getRecommendations(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + '/get-recommendations',
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_RECOMMENDATIONS_REQUESTED,
        data: response.data
      });
    } else {
      yield put({ type: types.GET_RECOMMENDATIONS_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_RECOMMENDATIONS_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* getAwaitingParticipantDatingDays(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + '/get-awaiting-participant-datingDays',
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_AWAITING_PARTICIPANT_DATING_DAYS_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_AWAITING_PARTICIPANT_DATING_DAYS_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_AWAITING_PARTICIPANT_DATING_DAYS_FAILED,
      error
    });
  }
  store.dispatch(hideLoading());
}

function* changeSampleParticipation(action) {
  let response = null;
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATION + '/change-sample-participate',
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.CHANGE_SAMPLE_PARTICIPATION_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.CHANGE_SAMPLE_PARTICIPATION_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_AWAITING_PARTICIPANT_DATING_DAYS_FAILED,
      error
    });
  }
  store.dispatch(hideLoading());
}

function* renewExpiredInvoice(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.RENEW_EXPIRED_INVOICE,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.RENEW_EXPIRED_INVOICE_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.RENEW_EXPIRED_INVOICE_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.RENEW_EXPIRED_INVOICE_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* getMotivateImages(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.GET_MOTIVATE_IMAGES,
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_MOTIVATE_IMAGES_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_MOTIVATE_IMAGES_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_MOTIVATE_IMAGES_FAILED,
      error
    });
  }
  store.dispatch(hideLoading());
}
function* getUserTrialInfo(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.GET_USER_TRIAL_INFO,
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_USER_TRIAL_INFO_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_USER_TRIAL_INFO_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_USER_TRIAL_INFO_FAILED,
      error
    });
  }
  store.dispatch(hideLoading());
}

function* getCancelSampleDatingOptions(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.GET_CANCEL_SAMPLE_DATING_OPTIONS,
      API.GET,
      action.params
    );
    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_CANCEL_SAMPLE_DATING_OPTIONS_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_CANCEL_SAMPLE_DATING_OPTIONS_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_CANCEL_SAMPLE_DATING_OPTIONS_FAILED,
      error: response
    });
  }
  store.dispatch(hideLoading());
}

export function* watchGetRecommendations() {
  yield takeLatest(types.GET_RECOMMENDATIONS_REQUESTED, getRecommendations);
}
export function* watchRequestParticipate() {
  yield takeLatest(types.REQUEST_PARTICIPATE_REQUESTED, requestParticipate);
}
export function* watchCancelParticipate() {
  yield takeLatest(types.CANCEL_PARTICIPATE_REQUESTED, cancelParticipate);
}
export function* watchRequestAwaitingCancel() {
  yield takeLatest(
    types.REQUEST_AWAITING_CANCEL_REQUESTED,
    requestAwaitingCancel
  );
}
export function* watchCancelSampleParticipant() {
  yield takeLatest(
    types.CANCEL_SAMPLE_PARTICIPANT_REQUESTED,
    cancelSampleParticipant
  );
}
export function* watchGetAwaitingParticipantDatingDays() {
  yield takeLatest(
    types.GET_AWAITING_PARTICIPANT_DATING_DAYS_REQUESTED,
    getAwaitingParticipantDatingDays
  );
}
export function* watchRemoveFirstLoginAfterApprove() {
  yield takeLatest(
    types.REQUEST_FIRST_LOGIN_AFTER_APPROVED_REQUESTED,
    removeFirstLoginAfterApproved
  );
}

export function* watchRenewExpiredInvoice() {
  yield takeLatest(types.RENEW_EXPIRED_INVOICE_REQUESTED, renewExpiredInvoice);
}
export function* watchChangeSampleParticipation() {
  yield takeLatest(
    types.CHANGE_SAMPLE_PARTICIPATION_REQUESTED,
    changeSampleParticipation
  );
}
export function* watchGetMotivateImages() {
  yield takeLatest(types.GET_MOTIVATE_IMAGES_REQUESTED, getMotivateImages);
}
export function* watchGetUserTrialInfo() {
  yield takeLatest(types.GET_USER_TRIAL_INFO_REQUESTED, getUserTrialInfo);
}

export function* watchGetCancelSampleDatingOptions() {
  yield takeLatest(
    types.GET_CANCEL_SAMPLE_DATING_OPTIONS_REQUESTED,
    getCancelSampleDatingOptions
  );
}

// Prefecture Area Master function for Participation page
function* getPrefectureAreaMaster(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_GET_PREFECTURE_AREA_MASTER,
      API.GET,
      {},
      false
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_PREFECTURE_AREA_MASTER_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_PREFECTURE_AREA_MASTER_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_PREFECTURE_AREA_MASTER_FAILED,
      error
    });
  }
  store.dispatch(hideLoading());
}

// Watch function for prefecture area master
export function* watchGetPrefectureAreaMaster() {
  yield takeLatest(
    types.GET_PREFECTURE_AREA_MASTER_REQUESTED,
    getPrefectureAreaMaster
  );
}
